/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {useAuth} from '../../../../../auth'
import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {MapView} from '../../../../../../../_metronic/helpers/components/Help/MapView'
import {Modal} from 'react-bootstrap'
import {
  API_URL,
  KTIcon,
  isMegaPay,
  isOnline,
  projectName,
} from '../../../../../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import {ChangeCompany} from './ChangeCompany'
import {ONLINE_REGISTRATION_PATH} from '../../../../../auth/core/onlineRegistration'
import {BusinessOption} from '../../../../shared/business-switcher/BusinessOption'
import {
  businessOptionData,
  useBusinessSwitcherLabels,
} from '../../../../shared/business-switcher/businessSwitcherLabels'
import {useCurrentBusiness} from '../../../../shared/business-switcher/useCurrentBusiness'
import {staffCan, staffPicksBusiness} from '../../../../../auth/core/staffAccess'

interface companyInfo {
  status: string
  // type: string
  // taxidStatus: number
  // taxid: string
}

type props = {
  comboStyle?: React.CSSProperties
  isChangeable?: boolean
}

const CurrentCompany: FC<props> = ({isChangeable = false, comboStyle = {width: 'fit-content'}}) => {
  const Navigate = useNavigate()
  const {currentUser, setCurrentUser, saveAuth, logout} = useAuth()
  const [map, setMap] = useState(false)
  const [statusLoading, setStatusLoading] = useState(false)
  const [status, setStatus] = useState<companyInfo>()
  const businesses = currentUser?.cpl || []
  // A user with several businesses switches here as on the invoice list; one business is only shown.
  const changeable = isChangeable || businesses.length > 1
  const current = businesses.find((x) => x.id === Number(currentUser?.cpi))
  // The header's chip (BusinessChip) shows the tab's business on every page and chooses another, so a user's pages
  // no longer repeat it (the user, 2026-10-26); staff keep the pickers of the pages.
  const shownInHeader = Boolean(useCurrentBusiness()) && !staffPicksBusiness(currentUser)
  const labels = useBusinessSwitcherLabels(
    !changeable && current && !shownInHeader ? businesses : undefined
  )

  useEffect(() => {
    if (isMegaPay && !status) {
      //getStatus()
    }
  }, [])

  const getStatus = (force?: number) => {
    setStatusLoading(true)
    axios.get(`${API_URL}/company/status/${force && force == 1 ? 'true' : ''}`).then((response) => {
      setStatusLoading(false)
      setStatus(response.data as companyInfo)
    })
  }

  if (shownInHeader && !isOnline) return null

  return (
    <>
      {currentUser && (
        <>
          <div className='d-flex align-items-center'>
            {isOnline && (
              <div className='me-2 mobile-d-none'>
                <i className='las la-sitemap fs-2x link-warning' onClick={() => setMap(true)}></i>
              </div>
            )}
            {shownInHeader ? null : changeable ? (
              <ChangeCompany comboStyle={comboStyle} />
            ) : (
              current && <BusinessOption business={businessOptionData(current, labels[current.id])} />
            )}
            <div className='ms-2'>
              {statusLoading && <i className='las la-spinner fs-2x ms-5 la-spin'></i>}
              {!statusLoading && status && (
                <span
                  onClick={() => getStatus(1)}
                  className={clsx(
                    'fs-2',
                    status.status == 'ENABLED' || status.status == 'ACTIVE'
                      ? 'link-success'
                      : 'link-danger'
                  )}
                >
                  <i
                    className={clsx(
                      'las la-power-off fs-2x ms-5 me-2',
                      status.status == 'ENABLED' || status.status == 'ACTIVE'
                        ? 'link-success'
                        : 'link-danger'
                    )}
                    title='فعال مجاز'
                  ></i>
                  <span className='mobile-d-none'>
                    {status.status != null && (
                      <>
                        {status.status == 'ENABLED' || status.status == 'ACTIVE' ? (
                          <span className='link-success'>فعال</span>
                        ) : (
                          <span className='link-danger'>غیر فعال</span>
                        )}
                        <span>&nbsp;</span>
                      </>
                    )}
                    {/* {status.type != null && (
                      <>
                        {status.type == 'LEGAL' ? (
                          <span className='link-success'>مجاز</span>
                        ) : (
                          <span className='link-danger'>غیر مجاز</span>
                        )}
                        <span>&nbsp;</span>
                      </>
                    )}
                    {status.taxidStatus != null && status.taxid != null && (
                      <>
                        {status.taxidStatus == 0 ? (
                          <>{/* <span className='link-success'>{status.taxid}</span> */}
                    {/* </>
                        ) : (
                          <span className='link-danger'>{status.taxid}</span>
                        )}
                      </>
                    )} */}
                  </span>
                </span>
              )}
            </div>
          </div>
          {map && (
            <Modal
              id='kt_modal_create_app'
              tabIndex={-1}
              aria-hidden='true'
              dialogClassName='modal-dialog modal-dialog-centered mw-900px'
              show
              backdrop={true}
              onHide={() => setMap(false)}
            >
              <div className='modal-header d-flex'>
                <h2>دستیار {projectName}</h2>
                <div className='mobile-d-none'>
                  <ChangeCompany />
                </div>
                {staffCan(currentUser, 'businesses', 'manage') ? (
                  <div className='flex-grow-1 text-end me-5 mobile-d-none'>
                    <button
                      className='btn btn-success'
                      onClick={() => Navigate('/taxpayer/register')}
                    >
                      کسب‌وکار جدید
                    </button>
                  </div>
                ) : (
                  !currentUser?.support && (
                    <div className='flex-grow-1 text-end me-5 mobile-d-none'>
                      {/* Everyone else adds a business they own through the online sign-up. */}
                      <button
                        className='btn btn-light-success'
                        onClick={() => Navigate(ONLINE_REGISTRATION_PATH)}
                      >
                        افزودن کسب‌وکار
                      </button>
                    </div>
                  )
                )}
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  onClick={() => {
                    setMap(false)
                  }}
                >
                  <KTIcon className='fs-1' iconName='cross' />
                </div>
              </div>
              <div className='modal-body'>
                <MapView />
              </div>
            </Modal>
          )}
        </>
      )}
    </>
  )
}

export {CurrentCompany}
